import List from '@material-ui/core/List';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import withStyles from '@material-ui/core/styles/withStyles';

export const ListStyled = withStyles(() =>
  createStyles({
    root: {
      padding: '0px',
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
  }),
)(List);

export const useStyles = makeStyles(() => ({
  parentList: {
    margin: '-8px',
  },
}));
